export default __webpack_public_path__ + "static/media/roc_van_twente.daeedc78.svg";